"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decideMenuPosition = exports.calculateSpaceForMenu = exports.findOptionByKey = exports.findOptionBySelected = void 0;

var _react = _interopRequireDefault(require("react"));

var _value = require("../../skybase-core/utils/value");

var _constants = require("./constants");

var _constants2 = require("../sb-select-option/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AUTO_TOP = _constants.menuPositions.AUTO_TOP,
    BOTTOM_LEFT = _constants.menuPositions.BOTTOM_LEFT,
    TOP_LEFT = _constants.menuPositions.TOP_LEFT;

var findOptionBySelected = function findOptionBySelected(_ref) {
  var options = _ref.options,
      selected = _ref.selected;

  if (!options || !options.length || (0, _value.isNullOrUndefined)(selected)) {
    return null;
  }

  var selectedOptions = []; // check if options are `items` type or `component` type

  var formattedOptions = options[0].props ? convertItemComponentToOptionObject(options) : options;

  if (!Array.isArray(selected) || selected.length === 1) {
    return findOptionByKey({
      options: formattedOptions,
      key: Array.isArray(selected) ? selected[0] : selected
    });
  }

  selected.forEach(function (key) {
    var option = findOptionByKey({
      options: formattedOptions,
      key: key
    });

    if (option) {
      // do not push <NOT_FOUND> keys
      // if the selected-option is sub-option, it was not converted before, therefore it needs to be converted now.
      selectedOptions.push(option.props ? convertItemComponentToOptionObject([option])[0] : option);
    }
  });
  var result = selectedOptions.filter(function (option) {
    return Object.keys(option).length;
  });
  return result.length > 1 ? result : result[0];
};

exports.findOptionBySelected = findOptionBySelected;

var findOptionByKey = function findOptionByKey(_ref2) {
  var _options$find;

  var options = _ref2.options,
      key = _ref2.key;
  return (_options$find = options.find(function (option) {
    return option.value === key;
  })) !== null && _options$find !== void 0 ? _options$find : findSubOptionByKey({
    options: options,
    key: key
  });
};

exports.findOptionByKey = findOptionByKey;

var findSubOptionByKey = function findSubOptionByKey(_ref3) {
  var options = _ref3.options,
      key = _ref3.key;
  var result = null;
  options.forEach(function (option) {
    var _option$props;

    var subOptions = option.options || ((_option$props = option.props) === null || _option$props === void 0 ? void 0 : _option$props.children) || null;

    if ((subOptions === null || subOptions === void 0 ? void 0 : subOptions.length) && (!result || !result.length)) {
      result = subOptions.filter(function (subOption) {
        var _subOption$props;

        return subOption.value === key || ((_subOption$props = subOption.props) === null || _subOption$props === void 0 ? void 0 : _subOption$props.value) === key;
      });
    }
  });
  return Array.isArray(result) && result.length ? result[0] : null;
};

var convertItemComponentToOptionObject = function convertItemComponentToOptionObject(components) {
  return components.map(function (component) {
    var _component$props = component.props,
        children = _component$props.children,
        restProps = _objectWithoutProperties(_component$props, ["children"]);

    if (typeof children !== 'string' && typeof children !== 'number') {
      return _objectSpread(_objectSpread({}, restProps), {}, {
        options: children ? _react.default.Children.map(children, function (child) {
          return _objectSpread(_objectSpread({}, child), (child === null || child === void 0 ? void 0 : child.children) ? {
            title: child.children
          } : null);
        }) : undefined
      });
    }

    return _objectSpread(_objectSpread({}, restProps), children ? {
      title: children
    } : {});
  });
};
/*
The recursive function that calculates the height of the menu (consisted of options, groups and dividers).
 */


var calculateMenuItemHeight = function calculateMenuItemHeight(items) {
  var height = 0;
  items.forEach(function (item) {
    if (item.options && Array.isArray(item.options)) {
      height += _constants.GROUP_PX_HEIGHT + calculateMenuItemHeight(item.options);
    } else if (item.componentType === _constants2.COMPONENT_TYPE.DIVIDER) {
      height += _constants.DIVIDER_PX_HEIGHT;
    } else {
      height += _constants.OPTION_PX_HEIGHT;
    }
  });
  return height;
};
/*
Calculates the space above and below the node (button) and returns, whether the menu can be fit there.
 */


var calculateSpaceForMenu = function calculateSpaceForMenu(_ref4) {
  var node = _ref4.node,
      items = _ref4.items,
      maxHeight = _ref4.maxHeight;

  if (!node || !items || !items.length) {
    return {
      canFitTop: false,
      canFitBottom: false
    };
  }

  var windowHeight = window.innerHeight;
  var nodeDistanceFromTop = node.getBoundingClientRect().top;
  var nodeDistanceFromBottom = node.getBoundingClientRect().bottom; // distance_from_bottom means distance from TOP + the height of the node ---> might be misleading

  var menuHeight = _constants.MENU_MARGIN_PX_HEIGHT + (maxHeight !== null && maxHeight !== void 0 ? maxHeight : calculateMenuItemHeight(items));
  var canFitTop = nodeDistanceFromTop - menuHeight >= 0;
  var canFitBottom = nodeDistanceFromBottom + menuHeight <= windowHeight;
  return {
    canFitTop: canFitTop,
    canFitBottom: canFitBottom
  };
};
/*
When menuPosition is set to `auto/auto-top/auto-bottom` this function decides, what the final position will be.
 */


exports.calculateSpaceForMenu = calculateSpaceForMenu;

var decideMenuPosition = function decideMenuPosition(_ref5) {
  var canFitTop = _ref5.canFitTop,
      canFitBottom = _ref5.canFitBottom,
      menuPosition = _ref5.menuPosition;

  if (!canFitTop && !canFitBottom) {
    return menuPosition === AUTO_TOP ? TOP_LEFT : BOTTOM_LEFT;
  }

  if (menuPosition === AUTO_TOP) {
    return canFitTop ? TOP_LEFT : BOTTOM_LEFT;
  }

  return canFitBottom ? BOTTOM_LEFT : TOP_LEFT;
};

exports.decideMenuPosition = decideMenuPosition;
//# sourceMappingURL=utils.js.map